import { getConsent, setConsent, applyConsent } from "../helpers/consent.js";

export default {
  showCookieBanner() {
    console.log("showCookieBanner");
    document.body.classList.add("show-cookie-banner");
  },

  hideCookieBanner() {
    console.log("hideCookieBanner");
    document.body.classList.remove("show-cookie-banner");
  },

  check() {
    if (!this.consent.hasOwnProperty("analytics")) {
      this.showCookieBanner();
    }
  },

  init() {
    this.consent = getConsent();
    if (this.consent.hasOwnProperty("analytics") && this.consent.analytics) {
      applyConsent(this.consent);
    }
    document.querySelectorAll("[data-consent-accept]").forEach((button) => {
      button.addEventListener("click", () => {
        const types = button.dataset.consentAccept.split("|");
        types.forEach((type) => {
          this.consent[type] = true;
        });
        setConsent(this.consent);
        this.hideCookieBanner();
      });
    });

    document.querySelectorAll("[data-consent-reject]").forEach((button) => {
      button.addEventListener("click", () => {
        const types = button.dataset.consentReject.split("|");
        types.forEach((type) => {
          this.consent[type] = false;
        });
        setConsent(this.consent);
        this.hideCookieBanner();
      });
    });
  },
};
